module.exports = __webpack_public_path__ + "static/img/18.23749c63.png";